<script>
import { onMounted, onUnmounted } from 'vue'

import stateStore from "@/store";

export default {
	setup() {
		onMounted(() => {
			stateStore.state.load = true;
		})

		onUnmounted(() => {
			stateStore.state.load = false;
		})

		return () => null;
	}
}
</script>

<style>
</style>